import { render, staticRenderFns } from "./granary.vue?vue&type=template&id=fed95034&scoped=true&"
import script from "./granary.vue?vue&type=script&lang=js&"
export * from "./granary.vue?vue&type=script&lang=js&"
import style0 from "./granary.vue?vue&type=style&index=0&id=fed95034&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed95034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fed95034')) {
      api.createRecord('fed95034', component.options)
    } else {
      api.reload('fed95034', component.options)
    }
    module.hot.accept("./granary.vue?vue&type=template&id=fed95034&scoped=true&", function () {
      api.rerender('fed95034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/granary.vue"
export default component.exports